{
  "title": "Gói & Thanh toán",
  "tabs": {
    "subscription": "Gói đăng ký",
    "invoices": "Hoá đơn"
  },
  "plan": {
    "free": "Miễn phí",
    "plus": "Plus",
    "pro": "Pro"
  },
  "status": {
    "TRIALING": "Dùng thử",
    "ACTIVE": "Đang hoạt động",
    "renewalStopped": "Đã dừng gia hạn"
  },
  "invoiceStatus": {
    "PENDING": "Chờ thanh toán",
    "PAID": "Đã thanh toán",
    "EXPIRED": "Đã hết hạn"
  },
  "planBadge": {
    "trial": "Dùng thử"
  },
  "periodEnds": "Hết kỳ vào {{date}}",
  "periodEndsCycle": "Hết kỳ vào {{date}} · {{cycle}}",
  "cycleMonthlyShort": "trả theo tháng",
  "cycleAnnualShort": "trả theo năm",
  "nextInvoice": "Ngày {{date}} LopHoc tạo hoá đơn kỳ tới để bạn quét QR. Không có thẻ nào bị trừ tự động.",
  "autoRenewOff": "Bạn dùng {{plan}} bình thường đến {{date}}. Sau ngày đó tài khoản tự về gói Free. Dữ liệu giữ nguyên, không mất gì.",
  "stopRenewal": "Dừng tạo hoá đơn kỳ tới",
  "trialEnds": "Dùng thử đến {{date}}",
  "freeNoExpiry": "Gói miễn phí: không có thời hạn sử dụng",
  "scheduledChange": "Đã thanh toán gói {{plan}}, áp dụng từ {{date}}",
  "upgrade": {
    "title": "Nâng cấp gói của bạn",
    "subtitle": "So sánh các gói để chọn gói phù hợp nhất với nhu cầu của bạn.",
    "tiers": {
      "free": "Miễn phí",
      "plus": "Plus",
      "pro": "Pro",
      "center": "Center"
    },
    "price": {
      "free": "Miễn phí",
      "perMonth": "{{amount}}/tháng",
      "perYear": "{{amount}}/năm",
      "annualPerMonth": "{{amount}}/tháng",
      "annualNote": "tiết kiệm {{save}}/năm · trả một lần {{total}}/năm"
    },
    "rows": {
      "students": "Học viên",
      "seats": "Giáo viên (seats)",
      "core": "Điểm danh, thời khoá biểu, chốt sổ",
      "noWatermark": "Không watermark trên hoá đơn",
      "qrPayment": "Tạo QR nhận tiền (VietQR)",
      "autoReconcile": "Tự động đối soát",
      "autoReconcileManual": "Thủ công",
      "aiCredits": "Tin nhắn AI / tháng",
      "aiImport": "Nhập liệu bằng AI",
      "sessionNotes": "Nhận xét buổi và nhận xét tháng",
      "progressLink": "Sổ liên lạc phụ huynh + ảnh bài về nhà",
      "bookkeeping": "Sổ sách + bán phụ",
      "zns": "Tự gửi hoá đơn qua Zalo ZNS",
      "payroll": "Chia lương",
      "multiBranch": "Nhiều trung tâm / chi nhánh"
    },
    "currentPlan": "Gói hiện tại",
    "ctaChoose": "Chọn gói",
    "cta": "Nâng cấp",
    "comingSoon": "Sắp có",
    "cycle": {
      "monthly": "Hàng tháng",
      "annual": "Hàng năm"
    },
    "annualSave": "Tiết kiệm 20%",
    "enterprise": {
      "body": "Trên 500 giao dịch đối soát/tháng, chuỗi lớn, whitelabel, hoặc ứng dụng AI vào vận hành trung tâm của bạn? ThinkSwarm (đội ngũ đã xây LopHoc cùng trung tâm thật) trực tiếp triển khai.",
      "cta": "Nhắn Zalo →"
    }
  },
  "choose": {
    "titleTrial": "Chọn gói để giữ tính năng sau khi hết dùng thử",
    "titleUpgrade": "Nâng gói",
    "compare": "So sánh đầy đủ",
    "ctaChoose": "Chọn gói {{plan}}",
    "ctaUpgrade": "Nâng lên {{plan}}",
    "annualSub": "tiết kiệm {{save}}/năm · trả một lần {{total}}/năm",
    "perMonthSuffix": "/tháng",
    "monthlySub": "thanh toán hàng tháng",
    "summary": {
      "PLUS": "Học viên không giới hạn · 2 ghế giáo viên · tự đối soát 60 gd/tháng · import bằng AI",
      "PRO": "Thêm sổ thu chi + bán thêm, lương giáo viên, bỏ watermark · 150 gd/tháng · 2.000 credit AI",
      "CENTER": "20 ghế giáo viên · tự đối soát 500 gd/tháng · 5.000 credit AI"
    }
  },
  "reassure": {
    "noAutoCharge": "Không có thẻ nào bị trừ tự động. Mỗi kỳ LopHoc tạo hoá đơn để bạn quét QR thanh toán.",
    "quotaSoft": "Hết quota thì phần mềm chỉ ngừng làm tự động. Dữ liệu vẫn còn nguyên và bạn vẫn ghi tay được bình thường.",
    "payEarly": "Trả sớm không mất gì: kỳ mới cộng thêm vào phần còn lại của kỳ này."
  },
  "highestPlan": "Bạn đang ở gói cao nhất",
  "unlimited": "Không giới hạn",
  "usage": {
    "studentsBar": "Học viên",
    "studentsUnlimitedValue": "không giới hạn",
    "studentsNearLimit": "Còn 1 chỗ học viên. Từ gói Plus trở lên là không giới hạn.",
    "aiCreditsBar": "Credit AI tháng này",
    "reconcileBar": "Tự khớp chuyển khoản tháng này",
    "reconcileOff": "Gói hiện tại chưa có tự khớp chuyển khoản. Nâng gói để phần mềm tự ghi nhận thanh toán.",
    "reconcileExhausted": "Đã hết lượt tự khớp tháng này. Tiền phụ huynh chuyển vẫn về tài khoản của bạn bình thường, nhưng phần mềm tạm thời không tự ghi nhận nữa. Bạn đánh dấu đã thanh toán bằng tay cho những khoản này. Đầu tháng sau tự mở lại, hoặc nâng gói để mở lại ngay.",
    "reconcileExhaustedCta": "Nâng gói"
  },
  "resume": "Bật lại",
  "resumeLink": "Bật lại gia hạn",
  "invoicesEmpty": "Chưa có hoá đơn gói nào",
  "invoicesEmptyHint": "Mỗi lần bạn mua gói hoặc gia hạn, hoá đơn sẽ nằm ở đây kèm mã chuyển khoản và trạng thái. LopHoc không giữ thẻ của bạn nên không có khoản nào bị trừ tự động.",
  "invoicePaidOn": "Đã thanh toán {{date}}",
  "invoice": {
    "paymentInstructions": "Chuyển khoản với nội dung sau để kích hoạt gói",
    "scanQr": "Quét mã bằng app ngân hàng",
    "ref": "Nội dung CK",
    "bank": "Ngân hàng",
    "accountNo": "Số TK",
    "accountName": "Tên TK",
    "iPaid": "Tôi đã chuyển khoản",
    "iPaidHint": "Hệ thống sẽ tự kích hoạt gói khi nhận được chuyển khoản, thường trong vòng một hai phút. Giữ nguyên nội dung chuyển khoản để việc này diễn ra tự động.",
    "iPaidZaloCta": "Có vấn đề? Nhắn Zalo cho LopHoc.app",
    "copy": "Sao chép",
    "copied": "Đã sao chép",
    "expired": "Hoá đơn này đã hết hạn. Tạo lại đơn nâng cấp từ trang Gói & Thanh toán.",
    "devMockPay": "Dev: Mô phỏng đã thanh toán",
    "devMockPayHint": "Chỉ hiện ở môi trường thử nghiệm (dev/demo), dùng để kiểm thử luồng dùng thử → trả phí khi chưa có đối soát tự động cho hoá đơn gói.",
    "devMockPayError": "Mô phỏng thanh toán thất bại.",
    "paidTitle": "Đã nhận thanh toán",
    "justPaidTitle": "Thanh toán thành công!",
    "paidAmount": "Số tiền",
    "paidAt": "Thời điểm",
    "paidPeriod": "Sử dụng đến",
    "backToBilling": "Về Gói & Thanh toán",
    "waiting": "Đang chờ chuyển khoản…",
    "recheck": "Kiểm tra lại",
    "stoppedWatching": "Đã ngừng tự kiểm tra sau 10 phút.",
    "orderTitle": "Đơn hàng",
    "planLabel": "Gói",
    "cycleLabel": "Chu kỳ",
    "periodLabel": "Kỳ sử dụng",
    "totalLabel": "Tổng thanh toán",
    "payTitle": "Quét mã để thanh toán",
    "cycleMonthly": "Hàng tháng",
    "cycleAnnual": "Hàng năm",
    "breakdown": {
      "title": "Số tiền này tính ra sao",
      "sameCycleLine": "Đây là phần chênh lệch giữa {{fromPlan}} và {{toPlan}} cho {{days}} ngày còn lại của kỳ hiện tại. Bạn không phải mua lại từ đầu.",
      "sameCycleRate": "Tính theo {{diff}} cho mỗi {{cycleDays}} ngày, làm tròn xuống nghìn.",
      "sameCycleKeepsRenewal": "Ngày gia hạn giữ nguyên: {{date}}.",
      "crossFullPrice": "Giá {{toPlan}} cho kỳ mới",
      "crossCredit": "Trừ phần chưa dùng của {{fromPlan}}",
      "crossNote": "Đổi chu kỳ là bắt đầu một kỳ mới nên ngày gia hạn tính lại từ hôm nay. Phần {{fromPlan}} bạn chưa dùng không mất đi, mà được trừ thẳng vào hoá đơn này."
    },
    "discount": {
      "title": "Ưu đãi",
      "listLabel": "Giá gói",
      "line": "Ưu đãi {{name}} (−{{pct}}%)"
    }
  },
  "cancelConfirm": {
    "title": "Dừng tạo hoá đơn kỳ tới?",
    "body": "Bạn vẫn dùng gói {{plan}} bình thường đến hết ngày {{date}}. Hệ thống sẽ không tạo hoá đơn gia hạn nữa, và sau ngày đó tài khoản chuyển về gói Miễn phí. Dữ liệu vẫn được giữ nguyên. Bạn có thể khôi phục bất cứ lúc nào trước ngày hết hạn.",
    "confirm": "Dừng tạo hoá đơn",
    "back": "Không, giữ nguyên"
  },
  "resumeConfirm": {
    "title": "Bật lại gia hạn?",
    "body": "Hệ thống sẽ tạo lại hoá đơn gia hạn gói {{plan}} trước ngày {{date}} để bạn thanh toán, và gói tiếp tục chạy không gián đoạn."
  },
  "prorationHint": "Nâng gói giữa kỳ chỉ tính phần chênh lệch cho số ngày còn lại. Ngày gia hạn giữ nguyên.",
  "pendingCallout": {
    "title": "Hoá đơn chờ thanh toán · {{amount}}",
    "body": "Quét QR thanh toán trước {{date}} để {{plan}} chạy liên tục. Chưa trả đến ngày đó thì tài khoản về gói Free. Dữ liệu giữ nguyên, bạn mua lại lúc nào cũng được.",
    "bodyNeutral": "Quét QR thanh toán trước {{date}}.",
    "cta": "Quét QR thanh toán",
    "cancel": "Huỷ hoá đơn",
    "cancelConfirmTitle": "Huỷ hoá đơn này?",
    "cancelConfirm": "Hoá đơn nâng gói này sẽ không còn hiệu lực. Gói bạn đang dùng không thay đổi gì. Bạn có thể chọn lại gói bất cứ lúc nào.",
    "cancelConfirmTerm": "Huỷ hoá đơn không phải là huỷ gói: bạn vẫn dùng {{plan}} bình thường đến hết ngày {{date}}. Sau ngày đó, nếu chưa có hoá đơn nào được thanh toán, tài khoản về gói Miễn phí. Dữ liệu giữ nguyên. Bạn thanh toán lại lúc nào cũng được trước ngày đó.",
    "cancelKeep": "Giữ hoá đơn",
    "cancelError": "Không huỷ được hoá đơn."
  },
  "nudge": {
    "TRIALING": {
      "title": "Còn {{days}} ngày dùng thử",
      "body": "Chọn gói để giữ lại toàn bộ tính năng sau khi hết dùng thử.",
      "cta": "Chọn gói"
    },
    "RENEWAL_DUE": {
      "title": "Sắp đến hạn gia hạn",
      "body": "Gói {{plan}} sẽ hết kỳ trong {{days}} ngày. Thanh toán để tiếp tục.",
      "cta": "Thanh toán"
    },
    "DOWNGRADED": {
      "title": "Gói của bạn đã chuyển về Miễn phí",
      "body": "Tự động đối soát chuyển khoản tạm dừng; dữ liệu của bạn vẫn còn nguyên vẹn.",
      "cta": "Chọn lại gói"
    },
    "TRIAL_ENDED": {
      "title": "Dùng thử đã kết thúc",
      "body": "Tài khoản đã chuyển về gói Miễn phí; dữ liệu của bạn vẫn còn nguyên vẹn.",
      "cta": "Chọn gói"
    },
    "dismiss": "Ẩn"
  },
  "offer": {
    "header": "Đang áp dụng ưu đãi {{name}}: giảm {{pct}}% kỳ đầu, còn tới {{deadline}}.",
    "firstTerm": "Kỳ đầu {{amount}} với {{name}}",
    "chip": "−{{pct}}% kỳ đầu",
    "countdown": {
      "days": "còn {{days}} ngày {{clock}}",
      "today": "còn {{clock}}",
      "trialMerge": "còn {{trialDays}} ngày dùng thử · ưu đãi {{offerCountdown}}"
    },
    "banner": {
      "label": "ƯU ĐÃI",
      "fallback": "Ưu đãi {{name}}: giảm {{pct}}% kỳ đầu cho mọi gói",
      "cta": "Nâng gói với ưu đãi",
      "dismiss": "Đóng"
    },
    "haveCode": "Có mã giảm giá?",
    "placeholder": "Nhập mã giảm giá",
    "apply": "Áp dụng",
    "applied": "Đã áp dụng mã {{code}}: giảm {{pct}}% kỳ đầu.",
    "campaignWins": "Chương trình {{name}} đang giảm nhiều hơn, hệ thống áp dụng mức {{pct}}%.",
    "clear": "Bỏ mã",
    "reason": {
      "INVALID": "Mã này không đúng. Bạn kiểm tra lại giúp mình nhé.",
      "EXPIRED": "Mã đã hết hạn.",
      "NOT_STARTED": "Mã chưa tới ngày áp dụng.",
      "PLAN": "Mã này không áp dụng cho gói bạn đang chọn.",
      "CYCLE": "Mã này không áp dụng cho chu kỳ bạn đang chọn.",
      "ALREADY_USED": "Tài khoản của bạn đã dùng mã này rồi.",
      "CAP": "Mã đã hết lượt sử dụng.",
      "STATUS": "Ưu đãi này dành cho tài khoản đang dùng thử hoặc đang ở gói Miễn phí."
    }
  }
}
